import {
  Container,
  Divider,
  Flex,
  Heading,
  Box,
  Grid,
  Skeleton,
} from '@chakra-ui/react';
import { useState, useEffect, useContext } from 'react';
import Breadcrumbs from '../../common/Breadcrumbs';

import { HttpContext } from '../../context/HttpContext';
import CountLimit from '../../components/client/usage/countLimit';
import ThroughputLimit from '../../components/client/usage/throughputLimit';
import Access from '../../components/client/usage/access';
import Enforcement from '../../components/client/usage/enforcement';

const UsagePage = () => {
  const { authAxios } = useContext(HttpContext);
  const [entitlements, setEntitlements] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const breadcrumbLinks = [
    { linkName: 'Home', linkUrl: '/' },
    { linkName: 'Resource Usage', linkUrl: '/usage' },
  ];

  const fetchEntitlements = async () => {
    try {
      setIsLoading(true);
      const data = await await authAxios.get(
        '/internal/v1/billing/subscriptions/current'
      );
      setEntitlements(data.data.subscription.entitlements);
    } catch (error) {
      console.error('Error fetching entitlements:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEntitlements();
  }, []);

  const renderSkeletonCards = () => {
    return Array.from({ length: 6 }, (_, index) => (
      <Box
        key={`skeleton-${index}`}
        p={4}
        border="1px solid"
        borderColor="gray.200"
        borderRadius="15px"
        w="100%"
        h="8rem"
      >
        <Skeleton height="20px" mb={2} />
        <Skeleton height="16px" mb={2} />
        <Skeleton height="16px" width="60%" />
      </Box>
    ));
  };

  return (
    <Container pb={6}>
      <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
      <Flex
        alignItems="center"
        mt="15px"
        py="9px"
        minH="54px"
        justifyContent="space-between"
        w="100%"
      >
        <Heading w="100%" data-testid="subscription-heading">
          Usage
        </Heading>
      </Flex>
      <Divider borderColor="primaryBackground" mb={6} />

      <Box
        w="100%"
        py={6}
        px={8}
        borderWidth="1px"
        borderRadius="15px"
        borderColor="gray.200"
        bg="white"
      >
        <Heading size="lg" mb="16px">
          Resources
        </Heading>
        <Grid templateColumns="repeat(2, 1fr)" gap={6}>
          {isLoading
            ? renderSkeletonCards()
            : entitlements &&
              entitlements.map((item) => (
                <Box
                  key={`${item.kind}:${item.key}`}
                  p={4}
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="15px"
                  w="100%"
                  h="8rem"
                >
                  {item.kind == 'countLimit' && (
                    <CountLimit entitlement={item} />
                  )}
                  {item.kind == 'throughputLimit' && (
                    <ThroughputLimit entitlement={item} />
                  )}
                  {item.kind == 'access' && <Access entitlement={item} />}
                  {item.kind == 'enforcement' && (
                    <Enforcement entitlement={item} />
                  )}
                </Box>
              ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default UsagePage;
